const handleTouch = async (e: TouchEvent | MouseEvent | KeyboardEvent) => {
    if (window.getSelection && window.getSelection()) {
        window.getSelection()!.removeAllRanges();
    }
    e.stopPropagation();
    let result = true;
    if (e.type === "touchstart") {
        result = await new Promise(resolve => {
            const onTouchend = (e: TouchEvent) => {
                e.preventDefault();
                window.removeEventListener("touchmove", onTouchmove);
                resolve(true);
            };
            const onTouchmove = (e: TouchEvent) => {
                window.addEventListener("touchend", onTouchend);
                resolve(false);
            };
            window.addEventListener("touchend", onTouchend, { once: true });
            window.addEventListener("touchmove", onTouchmove, { once: true });
        });
    }
    return result;
};

export default handleTouch;
